import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import girlIMG from "../../assets/app/Presentation/Chica-Banner.png";
import SpiderWebBackground from "../app/SpiderWebBackground";
import WhatsAppBanner from "../app/WhatsAppBanner";
import Nav from "../app/Nav";
import "../../styles/auth/Login.css";
import { login } from "../../services/login/Auth";
import LoadingSpinner from "../utility/LoadingSpinner";
import { jwtDecode } from "jwt-decode";

const Login: React.FC = () => {

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    localStorage.removeItem("user");
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");

    try {
      const response = await login({ email, password });

      if (response.status === 200) {
        const token = response.token;

        localStorage.setItem("token", token);

        const tokenWithoutBearer = token.replace("bearer ", "");

        const decoded = jwtDecode(tokenWithoutBearer);
        localStorage.setItem("user", JSON.stringify(decoded));

        setIsLoading(false);
        navigate("/dashboard");
      } else {
        setIsLoading(false);
        setErrorMessage(response.message || "Credenciales inválidas.");
      }

    } catch (error: any) {
      console.error("Error al iniciar sesión:", error);
      setIsLoading(false);
      const msg = typeof error === "string"
        ? error
        : error?.message || "Error desconocido al iniciar sesión";
      setErrorMessage(msg);
    }
  };

  return (
    <>
      {isLoading && <LoadingSpinner />}
      <WhatsAppBanner />
      <Nav />
      <SpiderWebBackground />
      <section id="login-section" className="login-main-container">
        <div className="login-content-wrapper">
          <div className="login-text-content">
            <h2 className="login-main-title">Iniciar Sesión</h2>
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="login-form-group">
                <label htmlFor="login-email" className="login-input-label">
                  Correo Electrónico
                </label>
                <input
                  type="email"
                  id="login-email"
                  className="login-form-input"
                  placeholder="ejemplo@correo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="login-form-group">
                <label htmlFor="login-password" className="login-input-label">
                  Contraseña
                </label>
                <input
                  type="password"
                  id="login-password"
                  className="login-form-input"
                  placeholder="********"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="login-submit-button">
                Entrar
              </button>

              {errorMessage && (
                <div className="login-error-message">
                  {errorMessage}
                </div>
              )}

            </form>
          </div>

          <div className="login-image-container">
            <img
              src={girlIMG}
              alt="Asistente virtual"
              className="login-featured-image"
              loading="eager"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;